import React from "react";
import { Container, Grid, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { Trans } from "react-i18next/icu.macro";
import Link from "./Link";
let isTrue = true;
export default function HomeStep() {
  const infoTitle1 = "Keep Your Simple Tasks Simple";
  const infoMsg1 =
    "PDF Converter is the first and only PDF software you’ll love. We have all the tools you’ll need to start, manage, and finish your work with digital documents.";
  const HomeSteps = [
    {
      title: "Compress the selected PDF file",
      subtitle:
        "Reducing the volume of the file will bring convenience to your file management and upload..",
      svg: "/images/img_compress.svg",
      link: "Start trying ->",
      path: "/compress-pdf",
      alt: "Compress the pdf into a smaller size",
    },
    {
      title: "Convert office to PDF",
      subtitle:
        "Office to PDF can quickly and directly convert Office files to PDF files, perfectly showing the style and layout of Office documents.",
      svg: "/images/img_office.svg",
      link: "Start conversion ->",
      path: "/word-to-pdf",
      alt: "Convert office files to pdf files",
    },
    {
      title: "Split a PDF file into multiple PDF files",
      subtitle:
        "After uploading a PDF document, it only takes a few seconds to split a PDF into multiple PDF documents, and the layout and format of the original PDF document are preserved.",

      svg: "/images/img_split.png",
      link: "Start split ->",
      path: "/split-pdf",
      alt: "Split the pdf file",
    },
  ];
  let [imagePosition, setImagePosition] = React.useState(-60);

  // 判断图片是否在可视区域的函数
  function isInSight(el) {
    const bound = el.getBoundingClientRect();
    const clientHeight = window.innerHeight;
    return bound.top <= clientHeight + 100;
  }
  function debounce(func, delay) {
    let timerId;
    return function (...args) {
      if (timerId) {
        clearTimeout(timerId);
      }
      timerId = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  }
  window.onscroll = debounce(scrollOn, 500);
  function scrollOn() {
    const homeStepImg = document.querySelectorAll(".homeStepImg");
    if (isInSight(homeStepImg[0])) {
      if (isTrue) {
        let animationID = setInterval(() => {
          imagePosition = imagePosition + 1;
          setImagePosition(imagePosition);
          if (imagePosition > 40) {
            clearInterval(animationID);
          }
        }, 100);
        isTrue = false;
      }
    } else {
      isTrue = true;
    }
  }
  return (
    <React.Fragment>
      {/* 上面背景色 */}
      <Box sx={{ height: "300px", marginTop: "100px" }} textAlign="center" className="homeStep">
        <Box
          sx={{
            position: "absolute",
            left: 0,
            right: 0,
            backgroundColor: "#EF5350",
          }}
        >
          <Box
            sx={{
              color: "#fff",
              textAlign: "center",
              paddingTop: "40px",
              position: "relative",
            }}
          >
            {/* title */}
            <Typography
              lineHeight="63px"
              positive="relative"
              variant="h3"
              component="span"
              sx={{ fontWeight: 500 }}
            >
              <Trans i18nKey={infoTitle1}>
                <strong> {infoTitle1} </strong>
              </Trans>
            </Typography>
            {/* subtitle */}
            <Typography
              fontSize="20px"
              lineHeight="25px"
              positive="relative"
              padding="40px 0"
              margin="auto"
              width="90%"
              sx={{
                color: "#fff",
              }}
            >
              <Trans i18nKey={infoMsg1}>{infoMsg1}</Trans>
            </Typography>
          </Box>
        </Box>
      </Box>

      <Container
        sx={{
          paddingTop: "100px",
          margin: "0 auto",
          width: "100%",
          "& :nth-of-type(2n+1)": { flexDirection: "row" },
          "& :nth-of-type(2n)": { flexDirection: "row-reverse" },
        }}
      >
        {HomeSteps.map((item, index) => (
          <Grid key={index} container columns={{ xs: 6, lg: 12 }} sx={{ marginBottom: "60px" }}>
            <Grid item xs={6}>
              <Box textAlign="left" paddingLeft="25px" sx={{ marginTop: "40px" }}>
                {/* title */}
                <Box>
                  <Typography
                    position="relative"
                    lineHeight="50px"
                    variant="subtitle2"
                    sx={{ fontWeight: 500 }}
                    positive="relative"
                    component="span"
                  >
                    <Trans i18nKey={item.title}>
                      <strong>{item.title}</strong>
                    </Trans>
                  </Typography>
                </Box>
                {/* subtitle */}
                <Typography
                  position="relative"
                  paddingTop="24px"
                  lineHeight="30px"
                  maxWidth="480px"
                  width="100%"
                  variant="body5"
                  sx={{
                    fontWeight: 500,
                  }}
                >
                  <Trans i18nKey={item.subtitle}>
                    <strong>{item.subtitle}</strong>
                  </Trans>
                </Typography>
                <Box>
                  <Link
                    href={item.path}
                    position="step"
                    onClick={() => {
                      sendConstructEventByEventParams("home", {
                        click_banner: item.path.slice(1),
                      });
                    }}
                    style={{ color: "#EF5350", lineHeight: "25px" }}
                  >
                    <Typography variant="body5">
                      <Trans i18nKey={item.link}>{item.link}</Trans>
                    </Typography>
                  </Link>
                </Box>
              </Box>
            </Grid>
            <Grid
              sx={{
                position: "relative",
              }}
              item
              xs={6}
            >
              <img
                className="homeStepImg"
                loading="lazy"
                alt={item.alt}
                style={{
                  width: "100%",
                  maxWidth: "1200px",
                  height: "auto",
                  margin: "auto",
                }}
                src={item.svg}
              />
              <img
                style={{
                  position: "absolute",
                  left: "0px",
                  bottom: imagePosition + "px",
                }}
                width="12%"
                src="/images/balloon.svg"
                alt="balloon.svg"
              />
            </Grid>
          </Grid>
        ))}
      </Container>
    </React.Fragment>
  );
}
